import BeforeCheckIn from './BeforeCheckInTemplate';
import AfterCheckIn from './AfterCheckInTemplate';

export default function templateFactory({ isParticipant, ...rest }) {
  if (isParticipant) return <AfterCheckIn {...rest} />;
  return <BeforeCheckIn {...rest} />;
}
